export enum DogEarType {
  LOCKED = 'locked',
  SPECIAL_ACCESS = 'special access',
  USDC_PURCHASE = 'usdc purchase',
  USDC_EXTRAS = 'usdc extras',
  TOKEN_GATED = 'token gated'
}
